import {
  RecruiterNotification,
  RecruiterNotificationGroup,
} from '../models/recruiter-notification.model';

const APPLICATION_GROUP_WINDOW_MS = 60 * 60 * 1000;

export function groupRecruiterNotifications(
  notifications: RecruiterNotification[]
): RecruiterNotificationGroup[] {
  const groups: RecruiterNotificationGroup[] = [];
  const sorted = [...notifications].sort(
    (left, right) =>
      new Date(right.createdAt).getTime() - new Date(left.createdAt).getTime()
  );

  sorted.forEach((notification) => {
    if (notification.type === 'NEW_APPLICATION') {
      const createdAt = new Date(notification.createdAt).getTime();
      const group = groups.find(
        (candidate) =>
          candidate.type === 'NEW_APPLICATION' &&
          candidate.jobId === notification.jobId &&
          Math.abs(new Date(candidate.createdAt).getTime() - createdAt) <=
            APPLICATION_GROUP_WINDOW_MS
      );

      if (group) {
        group.notifications.push(notification);
        group.candidateNames.push(notification.candidateName);
        group.itemCount += 1;
        group.read = group.read && Boolean(notification.readAt);
        return;
      }
    }

    groups.push({
      key:
        notification.type === 'NEW_APPLICATION'
          ? `${notification.type}:${notification.jobId}:${notification.id}`
          : `${notification.type}:${notification.sourceId}`,
      type: notification.type,
      notifications: [notification],
      applicationId: notification.applicationId,
      jobId: notification.jobId,
      jobTitle: notification.jobTitle,
      candidateNames: [notification.candidateName],
      itemCount:
        notification.type === 'CLARIFICATION_ANSWERS'
          ? notification.itemCount
          : 1,
      createdAt: notification.createdAt,
      read: Boolean(notification.readAt),
      clarificationRequestId:
        notification.type === 'CLARIFICATION_ANSWERS'
          ? notification.sourceId
          : undefined,
      candidateMessageId:
        notification.type === 'CANDIDATE_MESSAGE'
          ? notification.sourceId
          : undefined,
    });
  });

  return groups;
}

export function formatNotificationTime(
  value: string,
  now = new Date()
): string {
  const timestamp = new Date(value);
  if (Number.isNaN(timestamp.getTime())) return '';
  const seconds = Math.max(
    0,
    Math.floor((now.getTime() - timestamp.getTime()) / 1000)
  );
  if (seconds < 60) return 'Now';
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d`;
  return timestamp.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
  });
}
